export enum DoodOnSiteLocationSourceValues {
  fromUser = 'FROM_USER',
  fromQrCode = 'FROM_QR_CODE',
}
